import { QueryKey } from '@tanstack/react-query';
import Badge from 'components/badge/Badge';
import Switch from 'components/switch/Switch';
import {
  IntegrationStatus,
  InternalIntegrationSetting,
} from 'models/InternalIntegrationSetting';
import { useTranslation } from 'react-i18next';
import theme from 'styles/theme';
import { ToggleWithBadgeContainer } from '../StatusCell.styles';
import useToggleSwitch from './useToggleSwitch';

const DefaultSwitch = ({
  integrationSetting,
  queryKey,
  isPending,
}: {
  integrationSetting: InternalIntegrationSetting;
  queryKey: QueryKey;
  isPending: boolean;
}) => {
  const { t } = useTranslation();
  const { handleToggle, isToggleDisabled } = useToggleSwitch({
    integrationSetting,
    queryKey,
  });

  const isEnabled =
    integrationSetting.agencySettings.status === IntegrationStatus.ACTIVE ||
    isPending;

  return (
    <ToggleWithBadgeContainer>
      <Switch
        data-testid="integration-status-switch"
        className="small"
        checked={isEnabled}
        disabled={isToggleDisabled}
        onClick={(e) => {
          e.stopPropagation();
          handleToggle();
        }}
      />
      {isPending && (
        <Badge backgroundColor={theme.colors.hostfullyYellow}>
          {t('pageIntegrations.table.pending')}
        </Badge>
      )}
    </ToggleWithBadgeContainer>
  );
};

export default DefaultSwitch;
